import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class PenaltyDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"PENALTY"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "Penalty",
            buteur: event.detail?.buteur,
            butSucced: event.detail?.butSucced ?? true,
          };
    }

    get buteur() {
        return this.detail.buteur;
    }
    set buteur(value) {
        this.detail.buteur = value;
    }

    get butSucced() {
        return this.detail.butSucced;
    }

    set butSucced(value) {
        this.detail.butSucced = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "buteur", "butSucced"].includes(key)){
            let commentaire = "Penalty "

            if(!this.butSucced)
                 commentaire += "raté"
            else
                commentaire += "réussi"

            const buteurPlayer = getPlayer(this.buteur, match)
            const team = getTeam(this.team, match)

            if(this.buteur){
                if(buteurPlayer){
                    commentaire += ' de '+ buteurPlayer.lastname
                }
            }else if(team){
                commentaire += ' pour '+ team.name
            }

            commentaire += "! "

            

            this.text = commentaire
        }
    }
}